<h1 style="text-align: center;">{{"gipUserForgotPwd" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Title"}}</h1>

<app-formular *ngIf="!isLoading" [formBuilderInput]="modelInput" [formular]="formular"></app-formular>
<mat-spinner class="flexCenter centerHorizontally centerVertically" *ngIf="isLoading" style="min-height: 100px;"></mat-spinner>

<div style="height: 100px" *ngIf="enabledRecaptcha && siteKey != ''" style="text-align: -webkit-center;">
  <re-captcha [siteKey]="siteKey" (resolved)="resolved($event)">
  </re-captcha>
</div>
<br>

<button mat-raised-button (click)="newPassword()"
  [disabled]="!isNewPasswordEnabled()">{{"btn_newpwd" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>